import { cva } from 'class-variance-authority'
import React, { MouseEvent } from 'react'

import { IStatusTagVariants } from './status-tag.types'

const StatusVariants = cva(
  ' flex h-[26px] w-auto items-center justify-center gap-2 p-1 rounded-md ',
  {
    variants: {
      variant: {
        blue: 'bg-blue-50 text-white',
        silver: 'bg-gradient-to-r from-[ var(--grey-5, #F2F2F3)] to-medium-gray text-white',
        gold: 'bg-gradient-to-r from-[#DCCEAC] to-[#806844] text-white',
        white: 'bg-white opacity-80 text-dark-gray',
        transparent: 'text-dark-gray',
      },
    },
  }
)

const StatusCursor = cva('flex flex-shrink-0 text-center', {
  variants: {
    cursor: {
      pointer: 'cursor-pointer',
      default: 'default',
    },
  },
})

// rgba(220, 206, 172, 1), rgba(128, 104, 68, 1)
interface StatusTagProps {
  label?: string
  image?: string
  variant?: IStatusTagVariants
  children?: React.ReactNode
  onClick?: (e: MouseEvent<HTMLDivElement>) => void
  cursor?: 'pointer' | 'default'
}

export const StatusTag: React.FC<StatusTagProps> = ({
  label,
  variant = 'white',
  image,
  onClick,
  children,
  cursor = 'pointer',
}) => {
  return (
    <div className={StatusCursor({ cursor })} onClick={onClick}>
      <div className={StatusVariants({ variant })}>
        <span className="text-sm font-medium first-letter:uppercase">
          {label && label} {image && <img src={image} alt="status tag" />}
          {children}
        </span>
      </div>
    </div>
  )
}
